import React from 'react'
import NavbarTop from '../NavbarTop'
import LoginPage from '../loginpage/LoginPage'
import Footer from '../Footer'

function Login() {
  return (
    <div>
      <NavbarTop/>
      <LoginPage/>
      <Footer/>
    </div>
  )
}

export default Login
